<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pt-md-1 pt-xl-0 pb-3 px-0 px-sm-2 shadow-lg col-12 col-lg-11"
>
  <div class="jumbotron-fluid mx-0 px-0 mb-0 pb-1 col-md-12 col-lg-11">
    <div class="container mt-2 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Write-Off Principal
          </h3>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body mt-2 py-4 mb-5 mx-0 mx-sm-auto px-1 px-lg-auto shadow-lg"
      [hidden]="txnsApprovals.length !== 0"
    >
      <div class="row">
        <div class="col-12">
          <h5 class="rub-head4 text-center font-weight-bold py-1">
            There are no Written-Off Principals to approve
          </h5>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body mt-2 pt-2 mb-5 mx-auto pb-4 px-1 px-lg-auto shadow-lg"
      [hidden]="txnsApprovals.length === 0"
    >
      <form [formGroup]="userForm">
        <div class="item-header mb-2">
          <div class="row">
            <!--select all items-->
            <div class="col-12 ml-0 pl-0 mx-sm-auto px-sm-auto pt-1">
              <input
                id="allSelected"
                formControlName="selectAll"
                (click)="checkAllItems(!fval.selectAll.value)"
                type="checkbox"
                value=""
                class="ml-4 text-info"
                tooltip="Select All Loans"
              />
              Select All
            </div>
          </div>
        </div>
        <div class="iteration mb-2" formArrayName="txnApprovals">
          <div
            class="item-container my-1"
            *ngFor="let items of fval.txnApprovals['controls']; let idx = index"
          >
            <div
              class="list-card card mt-1 pt-2 mb-0 mx-auto px-0 pb-0 shadow-lg"
              [formGroupName]="idx"
            >
              <div class="list-card-body card-body my-0 py-0 mx-0">
                <div class="row my-0 py-0">
                  <div class="col-1 mx-0 px-0">
                    <!--select an item-->
                    <input
                      formControlName="approved"
                      (click)="deselectAll(idx)"
                      type="checkbox"
                      value=""
                      class="ml-1 text-info"
                    />
                  </div>
                  <div class="col-11">
                    <div class="row mx-md-0 px-md-0">
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Station:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"]
                                  .station.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-4 d-flex justify-content-start">
                            <span class="">Client ID:</span>
                          </div>
                          <div
                            class="col-8 d-flex justify-content-start font-weight-bold mx-0 px-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"]
                                  .clientId.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div class="col-3 d-flex justify-content-start">
                            <span class="">Client:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"]
                                  .client.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div
                            class="col-3 col-md-4 col-xl-3 d-flex justify-content-start"
                          >
                            <span class="">Product:</span>
                          </div>
                          <div
                            class="col-9 col-md-8 col-xl-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">
                              {{
                                fval.txnApprovals["controls"][idx]["controls"]
                                  .product.value
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="row">
                          <div
                            class="col-3 col-xl-4 d-flex justify-content-start"
                          >
                            <span class="">Amount:</span>
                          </div>
                          <div
                            class="col-9 col-xl-8 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">
                              <input
                                id="amount"
                                type="text"
                                formControlName="amount"
                                class="form-control my-2 my-md-1"
                                [ngClass]="{
                                  'is-invalid':
                                    (fval.txnApprovals['controls'][idx][
                                      'controls'
                                    ].amount.touched ||
                                      fval.txnApprovals['controls'][idx][
                                        'controls'
                                      ].amount.dirty) &&
                                    fval.txnApprovals['controls'][idx][
                                      'controls'
                                    ].amount.errors
                                }"
                                autocomplete="off"
                                (keyup)="onKey($event, idx)"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-3 col-md-2 col-xl-1 d-flex justify-content-start"
                      >
                        <span class="">Comment:</span>
                      </div>
                      <div
                        class="col-9 col-md-7 col-xl-9 d-flex justify-content-start font-weight-bold"
                      >
                        <span class="itemCreated">
                          {{
                            fval.txnApprovals["controls"][idx]["controls"]
                              .comment.value
                          }}
                        </span>
                      </div>
                      <div
                        class="col-12 col-md-3 col-xl-2 justify-content-end font-weight-bold"
                      >
                        <a class="text-dark pointerCursor">
                          <span
                            class="itemCreated"
                            (click)="
                              openModal(
                                template,
                                fval.txnApprovals['controls'][idx]['controls']
                                  .clientId.value
                              )
                            "
                            >Statement
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        class="d-flex mt-3 mb-0 py-2 mx-auto mx-md-5 px-md-5"
        [hidden]="txnsApprovals.length === 0"
      >
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="approveItems()"
        >
          <i class="fas fa-check"></i> Approve
        </button>
        <ngx-spinner class="bg-info" size="medium" type="ball-scale-multiple">
          <p class="text-light">Please wait...</p>
        </ngx-spinner>
        <label class="col" *ngIf="errored" class="text-danger">
          <!-- <i class="material-icons">Cancel</i> -->

          <ngx-alerts></ngx-alerts>
        </label>

        <label class="col" *ngIf="posted" class="text-danger">
          <!-- <i class="material-icons">Cancel</i> -->

          <ngx-alerts></ngx-alerts>
        </label>
        <button
          class="btn btn-info col-4 col-md-2 mx-auto px-0"
          (click)="rejectItems()"
        >
          <i class="fas fa-times"></i> Reject
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header bg-info">
    <h4 class="modal-title text-white">
      {{ checkedClient.customerName }}'s Statement
    </h4>
    <button
      type="button"
      class="pull-right close"
      data-dismiss="modal"
      aria-
      label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 pt-0 pb-1 mb-0">
        <div class="client-modal card mt-0 pt-0 px-0 shadow-lg">
          <div class="card-body mt-0 pt-1 pb-2 mx-0 px-2">
            <div class="iteration mb-2">
              <div class="item-container my-1" *ngFor="let item of statement">
                <div class="list-card card mt-1 py-1 mx-auto px-0 shadow-lg">
                  <div class="list-card-body card-body my-0 py-0 mx-0">
                    <div class="row my-0 py-0">
                      <div class="col-12">
                        <div class="row mx-md-0 px-md-0">
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Txn Date:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.dateTaken }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Txn Time:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.timeTaken }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Txn Type:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated"> Micro Loan </span>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Loan Amount: </span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{
                                    item.principalTaken + item.loanInterestTaken
                                      | number
                                  }}
                                </span>
                              </div>
                            </div>
                          </div> -->
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Principal Amount:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.principalTaken | number }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Interest Amount:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.loanInterestTaken | number }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Interest Rate:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{
                                    item.microloanCustomerLoanInterest | number
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Amount Paid:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{
                                    item.principalPaid + item.loanInterestPaid
                                      | number
                                  }}
                                </span>
                              </div>
                            </div>
                          </div> -->
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Principal Paid:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.principalPaid | number }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Int + Loan Paid:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.loanInterestPaid | number }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 col-lg-4">
                            <div class="row">
                              <div class="col-6 d-flex justify-content-start">
                                <span class="">Balance:</span>
                              </div>
                              <div
                                class="col-6 d-flex justify-content-start font-weight-bold"
                              >
                                <span class="itemCreated">
                                  {{ item.theBalance | number }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-info col-3 col-md-2 pull-right"
      (click)="modalRef.hide()"
    >
      Ok
    </button>
  </div>
</ng-template>
